import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';

import { cn } from '@/shared/lib/cn';

export const Progress = React.forwardRef<
  React.ComponentRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    /** Colour of the filled portion; defaults to the brand colour. */
    tone?: 'primary' | 'success' | 'warning' | 'destructive';
  }
>(function Progress({ className, value, tone = 'primary', ...props }, ref) {
  const clamped = Math.min(100, Math.max(0, value ?? 0));
  return (
    <ProgressPrimitive.Root
      ref={ref}
      value={clamped}
      className={cn('bg-muted relative h-2 w-full overflow-hidden rounded-full', className)}
      {...props}
    >
      {/* Sized rather than translated: `transform` is not direction-aware, so
          a translated indicator fills from the wrong edge under `dir="rtl"`.
          Width grows from the inline start in whichever direction applies. */}
      <ProgressPrimitive.Indicator
        className={cn('h-full rounded-full transition-[width] duration-500', {
          'bg-primary': tone === 'primary',
          'bg-success': tone === 'success',
          'bg-warning': tone === 'warning',
          'bg-destructive': tone === 'destructive',
        })}
        style={{ width: `${clamped}%` }}
      />
    </ProgressPrimitive.Root>
  );
});
